import { render, staticRenderFns } from "./guolv.vue?vue&type=template&id=5194ba4a&scoped=true&"
import script from "./guolv.vue?vue&type=script&lang=js&"
export * from "./guolv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5194ba4a",
  null
  
)

export default component.exports